import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import i18n from '../../i18n';
import _actions from '../../actions';
import DialogSelectList from './DialogSelectList';
import GreenCheck from '../svg/GreenCheck';
import ShowPassword from '../svg/ShowPassword';
import YesNoDialog from '../common/YesNoDialog';
import Clover from '../svg/Clover';
import constants from '../../constants';

class CloverSermons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPassword: false,
            cloverUsername: '',
            cloverPassword: '',
            showCloverProducts: false,
            showCloverPages: false,
        };
    }

    componentDidUpdate(prevProps) {
        if ((this.props.versions.select.mediaType === 4 && prevProps.alerts.data.find((a) => { return a.id === 'sermon-media-invalid'; }) === undefined && this.props.alerts.data.find((a) => { return a.id === 'sermon-media-invalid'; }) !== undefined) || (!prevProps.clearClover && this.props.clearClover)) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                showCloverProducts: false,
                showCloverPages: false,
                cloverPassword: '',
                cloverUsername: '',
            });
            this.props.versions.select.mediaType = 0;
            this.props.actions.updateProjectVersionbyParameter(this.props.versions.select.projectId, 'mediaType', 0);
        }
        if (prevProps.clover?.data !== this.props.clover?.data
            && this.props.clover?.data?.length > 0) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ showCloverProducts: true });
        }
        if (prevProps.clover?.pages !== this.props.clover?.pages
            && this.props.clover?.pages?.length > 0) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ showCloverPages: true });
        }
    }

  saveCloverPage = (pageId) => {
      this.props.actions.setSelectedCloverPage(
          pageId.value,
          this.props.clover.payload,
          this.props.clover.select,
          this.props.versions.select,
      );
      this.setState({
          showCloverPages: false,
          cloverPassword: '',
      });
  };

  saveCloverProduct = (productId) => {
      const selectedProduct = this.props.clover.data.find((n) => {
          return n.id === productId.value;
      });
      if (selectedProduct) {
          this.props.actions.getCloverProductPages(
              selectedProduct, this.props.clover.token, this.props.versions.select,
          );
      }
      this.setState({
          showCloverProducts: false,
          cloverPassword: '',
      });
  };

  toggleShowPassword = () => {
      this.setState((prevState) => { return { showPassword: !prevState.showPassword }; });
  };

  onKeyUpClover = (e) => {
      if (e.keyCode === 13) { this.connectToClover(); }
  };

  onChangeInput = (e) => {
      const { name } = e.target;
      const val = e.target.value;
      const stateObj = {};
      stateObj[name] = val;
      this.setState(stateObj);
  };

  connectToClover = () => {
      if (this.props.versions.select.mediaType) {
          this.showDisconnectConfirm();
      } else {
          this.props.actions.clearAlert('sermon-media-invalid');
          this.runCloverConnection();
      }
  };

  runCloverConnection = () => {
      if (this.state.cloverUsername && this.state.cloverPassword) {
          this.props.actions.getCloverProducts(
              this.state.cloverUsername, this.state.cloverPassword, this.props.versions.select,
          );
      } else {
          const id = 'cloverUPRequired';
          this.props.actions.addAlert({
              message: i18n.t('modules.sermons.clover.error1'),
              view: '/modules/sermons',
              type: 'error',
              dismissable: true,
              id,
          });

          setTimeout(() => {
              this.props.actions.clearAlert(id);
          }, 3000);
      }
  };

  clearCloverMedia = () => {
      this.showDisconnectConfirm(() => {
          this.props.handleDisconnect();
      });
  };

  clearCloverState = () => {
      this.setState({
          showCloverProducts: false,
          showCloverPages: false,
          cloverPassword: '',
          cloverUsername: '',
      });
  };

  showDisconnectConfirm = () => {
      this.setState({
          confirmDisconnect: true,
      });
  };

  closeYesNoDialog = () => {
      this.setState({
          confirmDisconnect: false,
      });
  };

  handleDisconnect = () => {
      this.props.handleDisconnect();
      this.setState({
          confirmDisconnect: false,
      });
      if (this.state.cloverUsername && this.state.cloverPassword) {
          this.runCloverConnection();
      }
  };

  render() {
      const showPasswordIcon = (
          <ShowPassword
              showPassword={this.state.showPassword}
              toggleShowPassword={this.toggleShowPassword}
          />
      );
      let cloverForm = (
          <div className="form-section show">

              <div data-qa="clover-username" id="clover-username" className="form-control clover-username">
                  <label data-qa="clover-username-label">{i18n.t('modules.sermons.clover.user')}</label>
                  <div className="input-wrapper">
                      <input
                          id="clover-username-field"
                          type="text"
                          onChange={this.onChangeInput}
                          value={this.state.cloverUsername}
                          name="cloverUsername"
                          placeholder="pastor@mychurch.com"
                          onKeyUp={this.onKeyUpClover}
                          data-qa="clover-username-input"
                      />
                  </div>
              </div>

              <div data-qa="clover-password" id="clover-password" className="form-control clover-password">
                  <label data-qa="clover-password-label">{i18n.t('modules.sermons.clover.pw')}</label>
                  <div className="input-wrapper">
                      <input
                          id="clover-password-field"
                          type={this.state.showPassword ? 'text' : 'password'}
                          onChange={this.onChangeInput}
                          value={this.state.cloverPassword}
                          name="cloverPassword"
                          placeholder="••••••••••"
                          onKeyUp={this.onKeyUpClover}
                          data-qa="clover-password-input"
                      />
                      <span id="show-hide-password" className="hide-password">
                          {showPasswordIcon}
                      </span>
                  </div>
              </div>

              {/* eslint-disable-next-line */}
              <a
                  data-qa="connect-clover-button"
                  id="connect-clover"
                  className="btn-secondary btn-block"
                  onClick={this.connectToClover}
              >
                  {i18n.t('connect')}
              </a>

          </div>
      );
      if (this.props.versions.select && this.props.versions.select.cloverAccountEmail) {
          cloverForm = (
              <div id="clover-logged-in" className="clover-logged-in show">
                  <GreenCheck />
                  <p>
                      Account:
                      <span>{this.props.versions.select.cloverAccountEmail}</span>
                  </p>

                  {/* eslint-disable-next-line */}
                  <a
                      id="disconnect-clover"
                      className="btn btn-sq btn-dark btn-sm"
                      onClick={this.clearCloverMedia}
                  >
                      {i18n.t('disconnect')}
                  </a>
              </div>
          );
      }
      return (
          <div data-qa="clover-section" id="clover-section" className="general-section clover-sites">

              {this.state.showCloverPages
        && (
            <DialogSelectList
                visible={this.state.showCloverPages}
                items={this.props.clover.pages}
                onSelect={this.saveCloverPage}
                description={i18n.t('modules.sermons.clover.select1')}
                valueKey="id"
                labelKey="name"
                close={this.clearCloverState}
                icon={<Clover />}
            />
        )}
              {this.state.showCloverProducts
        && (
            <DialogSelectList
                visible={this.state.showCloverProducts}
                items={this.props.clover.data}
                onSelect={this.saveCloverProduct}
                description={i18n.t('modules.sermons.clover.select2')}
                valueKey="id"
                labelKey="title"
                close={this.clearCloverState}
                icon={<Clover />}
            />
        )}
              <h2
                  data-qa="clover-section-header"
                  className="section-name"
              >
                  {i18n.t('modules.sermons.clover.header')}
              </h2>
              {cloverForm}
              {this.state.confirmDisconnect
        && (
            <YesNoDialog
                Message={this.props.versions.select.mediaType === constants.MediaType.find((mt) => { return mt.Name === 'Vimeo'; }).Id ? i18n.t('modules.sermons.vimeo.warning') : i18n.t('modules.sermons.confirm')}
                ExecuteAction={this.handleDisconnect}
                CloseDialog={this.closeYesNoDialog}
                Visible={this.state.confirmDisconnect}
                title="Disconnect Existing Source?"
            />
        )}
          </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CloverSermons);
